import React from 'react';
export function Footer() {
  return <footer className="w-full bg-bark-900 py-14" data-id="element-77" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-2xl px-5 text-center sm:px-8" data-id="element-78" data-mp="3gfsmebmgesmg">
        <p className="font-display text-lg font-semibold text-cream-100 sm:text-xl" data-id="element-79" data-mp="3gh3q6bfwg0dk">
          👨‍👩‍👧 KIT PADRES PRESENTES™
        </p>
        <p className="mt-4 text-sm leading-relaxed text-cream-200/70 sm:text-base" data-id="element-80" data-mp="36oxw8w6378vq">
          El sistema para padres y madres que quieren estar presentes sin tener más tiempo del que ya
          tienen.
        </p>
        <p className="mt-5 font-display text-base italic text-terracotta-300 sm:text-lg" data-id="element-81" data-mp="37o74x94c1ef">
          Porque estar presente no debería depender de tener más horas en el día.
        </p>
      </div>
    </footer>;
}